module.exports = __webpack_public_path__ + "static/media/forbidden_robe.ec91d0f3.png";